import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AppSettings } from '../../app.settings';

export type SendPasswordLinkUserType = 'passenger' | 'driver' | 'user';

@Component({
  selector: 'app-send-password-link-dialog',
  templateUrl: './send-password-link-dialog.component.html',
  styleUrls: ['./send-password-link-dialog.component.scss']
})
export class SendPasswordLinkDialogComponent implements OnChanges {
  @Input() visible = false;
  @Input() userName = '';
  @Input() userType: SendPasswordLinkUserType = 'passenger';
  @Input() header = 'Send Password Link';

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onSendWithoutSaving = new EventEmitter<string>();
  @Output() onSaveAndSend = new EventEmitter<string>();

  showEmail = true;

  emailForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [
      Validators.required,
      Validators.pattern(AppSettings.EMAIL_PATTERN)
    ])
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue === true) {
      this.resetForm();
    }
  }

  get emailControl(): UntypedFormControl {
    return this.emailForm.get('email') as UntypedFormControl;
  }

  get isEmailValid(): boolean {
    return this.emailForm.valid;
  }

  get profileLabel(): string {
    if (this.userType === 'driver') {
      return "driver's";
    }
    if (this.userType === 'user') {
      return "user's";
    }
    return "passenger's";
  }

  get defaultUserName(): string {
    if (this.userType === 'driver') {
      return 'Driver';
    }
    if (this.userType === 'user') {
      return 'User';
    }
    return 'Passenger';
  }

  toggleEmailVisibility(): void {
    this.showEmail = !this.showEmail;
  }

  cancel(): void {
    this.onCancel.emit();
    this.closeDialog();
  }

  sendWithoutSaving(): void {
    if (!this.isEmailValid) {
      this.emailForm.markAllAsTouched();
      return;
    }
    this.onSendWithoutSaving.emit(this.emailControl.value.trim());
    this.closeDialog();
  }

  saveAndSend(): void {
    if (!this.isEmailValid) {
      this.emailForm.markAllAsTouched();
      return;
    }
    this.onSaveAndSend.emit(this.emailControl.value.trim());
    this.closeDialog();
  }

  onHide(): void {
    this.resetForm();
    this.visibleChange.emit(false);
  }

  private closeDialog(): void {
    this.resetForm();
    this.visible = false;
    this.visibleChange.emit(false);
  }

  private resetForm(): void {
    this.emailForm.reset({ email: '' });
    this.showEmail = true;
  }
}
